import React, { useEffect, useMemo, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faCircleXmark } from '@fortawesome/free-solid-svg-icons';
import './../styles/Checkout.scss'
import bag from './../../assets/bag.svg';
import useCartStore from './../store/cartStore'; 
import useUserStore from '../store/userStore'; 
import { useLoadingStore } from '../store/loadingStore';
import useToastStore from '../store/toastStore';
import { CartItemDTO } from '../types/Cart';
import CustomerInfo from '../components/Checkout/CustomerInfo';
import { createOrder, createOrderLine, Order } from '../types/Order';
import { Customer, CustomerBranch } from '../types/Customer';
import { executeFetch, executePost, mediaUrl } from '../helper/Api';
import { useNavigate, useSearchParams } from 'react-router-dom'
import {startNexiPayment} from '../components/Checkout/NexiPayment';
import EshopCustomerInfo, {
  EshopCustomerInfoData,
} from '../components/Checkout/EshopCustomerInfo';
const Checkout = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [customer,setCustomer] = useState<Customer>(null)
  const [selectedBranch,setSelectedBranch] = useState<CustomerBranch>(null);
  const {  isAuthenticated,user} = useUserStore(); 
  const {setLoading} = useLoadingStore();
  const { cart, removeFromCart,getCart,updateCart } = useCartStore();
  const {showToast} = useToastStore();
  const navigate = useNavigate();
  const [editingItem, setEditingItem] = useState<{id: string, quantity: number} | null>(null);
const [eshopCustomer, setEshopCustomer] =
  useState<EshopCustomerInfoData>({
    name: '',
    surname: '',
    email: '',
    phone: '',
    address: '',
    city: '',
    zipcode: '',
    shipping: 'courier',
    payment: 'cod',
  });
  const shippingCost = eshopCustomer.shipping === 'courier' ? 3 : 0;
  const paymentCost = eshopCustomer.payment === 'cod' ? 2 : 0;
// const [cardValid, setCardValid] = useState(false);

const sum = useMemo(() => {
  return cart.reduce((total, item) => total + item.price * item.quantity, 0);
}, [cart]);

//const totalSum = useMemo(() => sum , [sum]);
const totalSum = useMemo(() => {
  return sum + shippingCost + paymentCost;
}, [sum, shippingCost, paymentCost]);

  const handleRemoveItem = async (id: string) => {
    setLoading(true);
    try{
      await removeFromCart(id);
      showToast('Cart updated!','success')
    }
    catch(error){
      showToast('Error product to cart!','error')
      console.error(error.message);
    }
    setLoading(false);
  };

  const handleUpdateItem = async (item : CartItemDTO) => {
    if (!editingItem || editingItem.id !== item.id) return;
    setLoading(true);
    try{
      await updateCart({...item, quantity: editingItem.quantity});
      showToast('Cart updated!','success')
    }
    catch(error){
      showToast('Error product to cart!','error')
      console.error(error.message);
    }
    setLoading(false);
  }
  
  const handleBranchChange = (branch : CustomerBranch) => {
    setSelectedBranch(branch);
  }
  const validateCheckout = (): boolean => {

  if (!eshopCustomer.name.trim()) {
    showToast('Παρακαλώ συμπληρώστε το όνομα.', 'error');
    return false;
  }

  if (!eshopCustomer.surname.trim()) {
    showToast('Παρακαλώ συμπληρώστε το επώνυμο.', 'error');
    return false;
  }

  if (!eshopCustomer.email.trim()) {
    showToast('Παρακαλώ συμπληρώστε το email.', 'error');
    return false;
  }

  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(eshopCustomer.email)) {
    showToast('Παρακαλώ εισάγετε ένα έγκυρο email.', 'error');
    return false;
  }

  if (!eshopCustomer.phone.trim()) {
    showToast('Παρακαλώ συμπληρώστε το τηλέφωνο.', 'error');
    return false;
  }

  if (!eshopCustomer.address.trim()) {
    showToast('Παρακαλώ συμπληρώστε τη διεύθυνση.', 'error');
    return false;
  }

  if (!eshopCustomer.city.trim()) {
    showToast('Παρακαλώ συμπληρώστε την πόλη.', 'error');
    return false;
  }

  if (!eshopCustomer.zipcode.trim()) {
    showToast('Παρακαλώ συμπληρώστε τον ταχυδρομικό κώδικα.', 'error');
    return false;
  }

  return true;
};


const handlePlaceOrder = async () => {
  if (!selectedBranch) {
    showToast('Please select Branch!', 'error');
    return;
  }

  if (!customer) {
    showToast('Please login in order to place Order!', 'error');
    return;
  }

  if (!validateCheckout()) {
    return;
  }

  // =========================
  // NEXI CARD PAYMENT
  // =========================
 if (eshopCustomer.payment === 'card') {
    try {
        setLoading(true);

        const res = await executePost<any, any>(
            'Payment/Nexi',
            {
                amount: totalSum,
                name: eshopCustomer.name,
                surname: eshopCustomer.surname,
                email: eshopCustomer.email,
                phone: eshopCustomer.phone,
                address: eshopCustomer.address,
                city: eshopCustomer.city,
                zipcode: eshopCustomer.zipcode
            },
            { auth: 'auth' }
        );

        if (res.error) {
            console.error(res.error);
            showToast('Αποτυχία σύνδεσης με Nexi.', 'error');
            return;
        }

        if (!res.data?.hostedPage) {
            console.error('Nexi response:', res.data);
            showToast('Δεν επιστράφηκε σελίδα πληρωμής.', 'error');
            return;
        }

        window.location.href = res.data.hostedPage;

    } catch (error) {
        console.error('Nexi payment error:', error);
        showToast('Αποτυχία σύνδεσης με Nexi.', 'error');
    } finally {
        setLoading(false);
    }

    return;
}

  // =========================
  // NORMAL PAYMENT
  // COD / BANK TRANSFER
  // =========================
  try {
    setLoading(true);

    const order = createOrder(
      customer.id,
      customer.tid,
      selectedBranch.id,
      customer.tsid
    );

    order.lines = cart?.map(item =>
      createOrderLine(
        0,
        item.productId,
        item.quantity,
        item.price
      )
    );

    const res = await executePost<Order, any>(
      'Order/SetOrder',
      order,
      { auth: 'auth' }
    );

    if (res.error) {
      showToast(
        'Κάτι πήγε λάθος κατά την ολοκλήρωση της παραγγελίας!',
        'error'
      );

      console.error(res.error.message);
    } else {
      showToast(
        'Επιτυχής ολοκλήρωση της παραγγελίας!',
        'success'
      );

      await getCart();
      navigate('/');
    }
  } catch (error) {
    console.error(error);

    showToast(
      'Κάτι πήγε λάθος κατά την ολοκλήρωση της παραγγελίας!',
      'error'
    );
  } finally {
    setLoading(false);
  }
};
const fetchCustomer = async () => {
        setLoading(true);
        try {
            const resp = await executeFetch<Customer>(`Customer/GetCustomerInfo`,{auth:'auth'})
          if(resp.error){
              console.error(resp.error.message);
          }else{
            setCustomer(resp.data);
            setSelectedBranch(resp.data?.branches?.length > 0 ? resp.data.branches[0] : null);
          }
        } catch (error) {
            setLoading(false);
          console.error("Error fetching Customer:", error);
        }
        setLoading(false);
    }



  useEffect(()=>{
    const fetchCart = async()=>{
        setLoading(true);
      await getCart();
      await  fetchCustomer();
      setLoading(false);
    }
    fetchCart();
  },[user,getCart])



  
  return (
    <>
    <div className='checkout-wrap'>
    <div className='checkout-info'>
        {/* <CustomerInfo customer={customer} selectedBranch={selectedBranch} setSelectedBranch={handleBranchChange}/> */}
     <EshopCustomerInfo
    data={eshopCustomer}
    setData={setEshopCustomer}
    // onCardValidityChange={setCardValid}
/>
    </div>
      {/* Cart Sidebar */}
        <div className="checkout-cart">
          {/* Cart Items List */}
          <div className="cart-items">
            {cart.length > 0 ? (
              cart.map((item) => (
                <div key={item.sku} className="cart-item">
                    <button
                    className="remove-btn"
                    onClick={() => handleRemoveItem(item?.id)}
                    >
                    <FontAwesomeIcon icon={faCircleXmark} />
                  </button>
                    <div className='product'>
                        <img
                         src={mediaUrl(item.image)}
                        alt={item.name}
                        className="product-banner"
                        />
                        <div className="product-details">
                            <div className="product-title">{item.name}</div>
                            <div className="product-sku">SKU: {item.sku}</div>
                        </div>
                        <div className="productPrices">
                            <div className="product-price">
                                {item.price} €
                            </div>
                            <div className="product-quantity">Quantity:
                                    <input
                                      type="number"
                                      
                                      value={editingItem?.id === item.id ? editingItem.quantity : item.quantity}
                                      onChange={(e) => setEditingItem({
                                        id: item.id,
                                        quantity: parseInt(e.target.value) || 1
                                      })}
                                      onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                          handleUpdateItem(item);
                                        }
                                      }}
                                      onBlur={() => handleUpdateItem(item)}
                                      placeholder="Enter destination URL"
                                      className="index-input"
                                    />
                                    </div>
                        </div>
                    </div>
                  
                
                </div>
              ))
            ) : (
              <p className="empty-cart">Your cart is empty.</p>
            )}
          </div>

          {/* Cart Footer */}
          {/* <div className="cart-footer">
            <div className='cf-title'>TOTAL</div>
        
            <div className="total-sum">
              Total: <span>{totalSum.toFixed(2)} €</span>
            </div>
            <button 
            onClick={handlePlaceOrder}
            disabled={!isAuthenticated}
            className="place-order-btn">Place Order</button>
          </div> */}
          <div className="cart-footer">

 <div className='cf-title'>ΣΥΝΟΛΟ</div>

<div className='subtotals'>

  <div className='sub'>
    Υποσύνολο:
    <span>{sum.toFixed(2)} €</span>
  </div>

  <div className='sub'>
    Αποστολή:
    <span>
      {shippingCost > 0
        ? `+${shippingCost.toFixed(2)} €`
        : 'Δωρεάν'}
    </span>
  </div>

  <div className='sub'>
    Πληρωμή:
    <span>
      {paymentCost > 0
        ? `+${paymentCost.toFixed(2)} €`
        : 'Δωρεάν'}
    </span>
  </div>

</div>

<div className="total-sum">
  Τελικό Σύνολο:
  <span>{totalSum.toFixed(2)} €</span>
</div>

<button
  onClick={handlePlaceOrder}
  className="place-order-btn"
>
  Ολοκλήρωση Παραγγελίας
</button>

</div>
</div>
    </div>
    </>
  );
};

export default Checkout;